"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EGenerationPatterns = exports.EAdCampaignType = void 0;
var EAdCampaignType;
(function (EAdCampaignType) {
    EAdCampaignType["EXACT"] = "EXACT";
    EAdCampaignType["INTERVAL"] = "INTERVAL";
    EAdCampaignType["PERIOD"] = "PERIOD";
})(EAdCampaignType = exports.EAdCampaignType || (exports.EAdCampaignType = {}));
var EGenerationPatterns;
(function (EGenerationPatterns) {
    EGenerationPatterns["WITH_MUSIC_CUT"] = "with_music_cut";
    EGenerationPatterns["WITHOUT_MUSIC_CUT"] = "without_music_cut";
})(EGenerationPatterns = exports.EGenerationPatterns || (exports.EGenerationPatterns = {}));
//# sourceMappingURL=enums.js.map